import { ChipOwnProps } from "@mui/material";
import { ResidentCaliber } from "../../entities/admin-events";

/**
 * Получить название калибра на русском языке
 */
export const renderCaliberName = (caliber: ResidentCaliber): string => {
  switch (caliber) {
    case ResidentCaliber.VOSHOD:
      return "Восходящая звезда";
    case ResidentCaliber.SIYAY:
      return "Сияющая звезда";
    case ResidentCaliber.SOVER:
      return "Совершенная звезда";
    default:
      return caliber;
  }
};

export const getCaliberColor = (
  caliber: ResidentCaliber
): ChipOwnProps["color"] => {
  switch (caliber) {
    case ResidentCaliber.VOSHOD:
      return "success";
    case ResidentCaliber.SIYAY:
      return "error";
    case ResidentCaliber.SOVER:
      return "info";
    default:
      return "default";
  }
};

/**
 * Получить короткое название калибра на русском языке
 */
export const renderCaliberShortName = (caliber: ResidentCaliber): string => {
  switch (caliber) {
    case ResidentCaliber.VOSHOD:
      return "Восход";
    case ResidentCaliber.SIYAY:
      return "Сияй";
    case ResidentCaliber.SOVER:
      return "Совер";
    default:
      return caliber;
  }
};

/**
 * Получить все доступные типы калибров с их названиями
 */
export const getCalibers = () =>
  [
    { value: "voshod", label: "Восход", fullLabel: "Восходящая звезда" },
    { value: "siyay", label: "Сияй", fullLabel: "Сияющая звезда" },
    { value: "sover", label: "Совер", fullLabel: "Совершенная звезда" },
  ] as const;
